import React from "react";
import "./tour6.css";
import { Link } from "react-router-dom";  
import { FaUmbrellaBeach, FaUsers, FaMapMarkerAlt, FaEnvelope, FaPhone, FaHome } from "react-icons/fa";

function Tour6() {
  return (
    <section className="tour4-container">
          <div className="banner">
          <img 
            src="/explore srilanka.png" 
            alt="Airport Pickup and Drop Banner" 
            className="banner-image" 
          />
        </div>
      {/* Title */}
      <h1 className="tour4-title">6-Day Adventure Tour in Sri Lanka: Nature and Excitement</h1>

      <div className="tour4-layout">
        {/* Left Section */}
        <div className="tour4-left">
          {/* Info Boxes */}
          <div className="tour4-info-cards">
            <div className="info-card">
              <FaUmbrellaBeach className="info-icon" />
              <div>
                <h4>Travel</h4>
                <p>5 Night, 6 Day</p>
              </div>
            </div>

            <div className="info-card">
              <FaUsers className="info-icon" />
              <div>
                <h4>Group Size</h4>
                <p>Family / Couple</p>
              </div>
            </div>

            <div className="info-card">
              <FaMapMarkerAlt className="info-icon" />
              <div>
                <h4>Destinations</h4>
                <p>Beach</p>
              </div>
            </div>
          </div>

          {/* Tour Highlights */}
          <div className="tour4-highlights">
            <h3>Tour Highlights:</h3>
            <p>Sigiriya, Kandy, Nuwara Eliya, and Yala National Park.</p>

            <div className="tour4-gallery">
              <img src="/negombo.png" alt="Negombo" />
             <img src="/bentota.jpg" alt="Bentota" />
               <img src="/Bentota-tour4.jpg" alt="Bentota" />
              <img src="/GALLE.jpg" alt="Galle Fort" />
              <img src="/galle-f.webp" alt="Galle Fort" />
              <img src="/turtles.jpg" alt="Turtle Hatchery" />
              <img src="/water-sports.jpg" alt="Water Sports" />
              <img src="/hort.jpg" alt="Colombo" />
               <img src="/waterf.jpg" alt="colombo" />
              <img src="/hortan.jpg" alt="Colombo" />
         
             
            </div>
          </div>

{/* Itinerary */}
<div className="tour6-itinerary">
  <h3>Day 1: Arrival and Sigiriya Exploration</h3>
  <ul>
    <li>Arrive at Bandaranaike International Airport.</li>
    <li>Transfer to Sigiriya, home to the ancient rock fortress.</li>
    <li>Activities:</li>
    <ul>
      <li>Climb the magnificent Sigiriya Rock Fortress.</li>
      <li>Admire the famous Sigiriya frescoes and ancient ruins.</li>
      <li>Enjoy breathtaking panoramic views from the summit.</li>
    </ul>
    <li>Overnight stay in Sigiriya.</li>
  </ul>

  <h3>Day 2: Dambulla Caves and Kandy Cultural Experience</h3>
  <ul>
    <li>Morning visit to Dambulla Cave Temple, a UNESCO World Heritage site.</li>
    <li>Proceed to Kandy, the cultural heart of Sri Lanka.</li>
    <li>Activities:</li>
    <ul>
      <li>Witness traditional Kandyan cultural dance performance.</li>
      <li>Visit the sacred Temple of the Tooth Relic.</li>
      <li>Evening stroll around beautiful Kandy Lake.</li>
    </ul>
    <li>Overnight stay in Kandy.</li>
  </ul>

  <h3>Day 3: Scenic Journey to Nuwara Eliya Hill Country</h3>
  <ul>
    <li>Picturesque drive through rolling tea plantations.</li>
    <li>Activities:</li>
    <ul>
      <li>Tour a working tea factory and sample authentic Ceylon tea.</li>
      <li>Explore Gregory Lake and enjoy boating activities.</li>
      <li>Visit Hakgala Botanical Garden with its exotic flora.</li>
    </ul>
    <li>Overnight stay in Nuwara Eliya.</li>
  </ul>

  <h3>Day 4: Horton Plains Adventure and Scenic Train to Ella</h3>
  <ul>
    <li>Early morning trek at Horton Plains National Park.</li>
    <li>Activities:</li>
    <ul>
      <li>Hike to World's End for spectacular cliff views.</li>
      <li>Visit the beautiful Baker's Falls.</li>
      <li>Experience the scenic train journey from Nanu Oya to Ella.</li>
    </ul>
    <li>Overnight stay in Ella.</li>
  </ul>

  <h3>Day 5: Yala National Park Wildlife Safari</h3>
  <ul>
    <li>Morning transfer to Yala National Park.</li>
    <li>Activities:</li>
    <ul>
      <li>Evening jeep safari through Yala's wilderness.</li>
      <li>Spot leopards, elephants, and diverse bird species.</li>
      <li>Explore ancient rock temples within the park.</li>
    </ul>
    <li>Overnight stay near Yala.</li>
  </ul>

  <h3>Day 6: Coastal Relaxation and Departure</h3>
  <ul>
    <li>Morning drive to Mirissa beach.</li>
    <li>Activities:</li>
    <ul>
      <li>Relax on the golden sands of Mirissa Beach.</li>
      <li>Optional whale watching experience (seasonal).</li>
      <li>Enjoy fresh seafood at beachside restaurants.</li>
    </ul>
    <li>Transfer to the airport for departure.</li>
  </ul>
</div>
        </div>

        {/* Right Sidebar */}
        <aside className="tour4-sidebar">
          <div className="sidebar-box">
            <h3>BOOK NOW TOURS</h3>
            <p>
              Ready to explore Sri Lanka’s beaches or need help planning your dream vacation? 
              Our team at <strong>Eco Rich Travels</strong> is here to assist you.
            </p>
            <Link to="/bookings" style={{ textDecoration: 'none' }}>
            <button className="btn-primary">BOOK TOUR</button>
            </Link>

           <button 
            className="btn-secondary"
            onClick={() => window.open(`https://wa.me/94742947134`, '_blank')}
          >
            Easy Quote
          </button>

          </div>

          <div className="sidebar-box contact-box">
            <h3>READY TO START YOUR ADVENTURE?</h3>
            <p>
              Book your tour today or reach out to us for any questions. We’re here to help you plan the perfect trip!
            </p>

            <div className="contact-details">
              <p><FaEnvelope /> info@ecorichtravels.com</p>
              <p><FaPhone /> +94 74 294 7134</p>
              <p><FaHome /> 520, Pamunugama Rd, Negombo</p>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}

export default Tour6;
